import * as XLSX from 'xlsx';

interface CajaMovement {
  caja_movement_id: number;
  workstation_id: number;
  workstation_name: string;
  user_id: number;
  user_name: string;
  before_amount: number;
  after_amount: number;
  amount: number;
  description: string | null;
  is_positive: boolean;
  caja_movement_type_id: number;
  caja_movement_type_name: string;
  caja_movement_metadata: any;
  timestamp: string;
  local_timestamp: string;
  session_id?: number;
  shift_id?: number | null;
  shift_name?: string | null;
  receipt_id?: number | null;
}

const formatDateTime = (timestamp: string): string => {
  if (!timestamp) return 'N/A';
  const date = new Date(timestamp);
  if (isNaN(date.getTime())) return 'N/A';
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

const transformMovimientosData = (movements: CajaMovement[]) => {
  return movements.map(movement => ({
    'ID Movimiento': movement.caja_movement_id,
    'Caja': movement.workstation_name,
    'Tipo de Movimiento': movement.caja_movement_type_name,
    'Usuario': movement.user_name,
    'Turno': movement.shift_name || 'N/A',
    'Fecha y Hora': formatDateTime(movement.local_timestamp || movement.timestamp),
    'Monto Anterior': Math.round(movement.before_amount),
    'Monto Posterior': Math.round(movement.after_amount),
    'Cambio': movement.is_positive 
      ? Math.round(movement.amount)
      : -Math.round(movement.amount),
    'Tipo': movement.is_positive ? 'Ingreso' : 'Egreso',
    'Descripción': movement.description || ''
  }));
};

export const exportMovimientosToExcel = (
  movements: CajaMovement[],
  startDate: string,
  endDate: string
) => {
  try {
    // Transform data
    const data = transformMovimientosData(movements);

    // Create workbook and worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);

    // Set column widths
    ws['!cols'] = [
      { wch: 15 }, // ID Movimiento
      { wch: 15 }, // Caja
      { wch: 20 }, // Tipo de Movimiento
      { wch: 20 }, // Usuario
      { wch: 20 }, // Turno
      { wch: 18 }, // Fecha y Hora
      { wch: 15 }, // Monto Anterior
      { wch: 15 }, // Monto Posterior
      { wch: 15 }, // Cambio
      { wch: 10 }, // Tipo
      { wch: 30 }  // Descripción
    ];

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Movimientos');

    // Generate filename with date range
    const filename = `Movimientos_Caja_${startDate}_a_${endDate}.xlsx`;

    // Write file
    XLSX.writeFile(wb, filename);

    return true;
  } catch (error) {
    console.error('Error exporting to Excel:', error);
    return false;
  }
};

export const exportFilteredMovimientos = (
  movements: CajaMovement[],
  startDate: string,
  endDate: string
) => {
  if (movements.length === 0) {
    return false;
  }
  return exportMovimientosToExcel(movements, startDate, endDate);
};
